const markDeclareReturn = [
    {
        "id": "1",
        "applicant": "楊小花",
        "operatorName": "簡單生活開發有限公司",
        "reportYear": "2021",
        "reportMonth": "12",
        "createdOn": "2022-01-15T00:00:00.000+08",
        "reviewComments": "確認印製數量是否正確",
        "products": [
            {
                "productName": "1",
                "spec": "150ml/瓶",
                "actualPrintedQuantity": 5300,
                "usageQuantity": 10250,
                "loseQuantity": 50,
                "inventoryQuantity": 0,
                "profitAndLoseQuantity": 100,
                "applyNotPrinted": 200,
                "reportQuantity": 5000,
                "overPrinted": 100,
                "inventoryLastMonth": 5000,
                "totalUsage": 10300,
                "reportNotPrinted": 0
            },
            {
                "productName": "2",
                "spec": "500g/罐",
                "actualPrintedQuantity": 500,
                "usageQuantity": 200,
                "loseQuantity": 50,
                "inventoryQuantity": 300,
                "profitAndLoseQuantity": 100,
                "applyNotPrinted": 300,
                "reportQuantity": 6000,
                "overPrinted": 300,
                "inventoryLastMonth": 6000,
                "totalUsage": 12000,
                "reportNotPrinted": 0
            }
        ],
    }
]

export default markDeclareReturn;